const STR = {
  he: {
    rain: 'גשם',
    temp: 'טמפ׳',
    wind: 'רוח',
    play: 'נגן',
    pause: 'השהה',
    locate: 'המיקום שלי',
    language: 'English',
    radar: 'מכ״ם',
    forecast: 'תחזית',
    now: 'עכשיו',
    loading: 'טוען מפה…',
    glanceLoading: 'בודקים אם ירד גשם…',
    glanceDry: 'לא צפוי גשם בקרוב',
    glanceRainSoon: (when) => `גשם צפוי בסביבות ${when}`,
    glanceRaining: 'יורד גשם עכשיו באזור',
    glanceUnknown: 'אין תחזית מיקום עדיין',
    forecastFromHere: 'תחזית מכאן',
    credits: 'מכ״ם RainViewer · תחזית Open-Meteo (ECMWF IFS) · מפה OpenFreeMap',
    willItRain: 'האם ירד גשם כאן?',
  },
  en: {
    rain: 'Rain',
    temp: 'Temp',
    wind: 'Wind',
    play: 'Play',
    pause: 'Pause',
    locate: 'My location',
    language: 'עברית',
    radar: 'Radar',
    forecast: 'Forecast',
    now: 'Now',
    loading: 'Loading map…',
    glanceLoading: 'Checking rain nearby…',
    glanceDry: 'No rain expected soon',
    glanceRainSoon: (when) => `Rain around ${when}`,
    glanceRaining: 'Rain nearby now',
    glanceUnknown: 'Location forecast unavailable',
    forecastFromHere: 'Forecast from here',
    credits: 'Radar RainViewer · Forecast Open-Meteo (ECMWF IFS) · Map OpenFreeMap',
    willItRain: 'Will it rain here?',
  },
};

export function t(lang, key, ...args) {
  const table = STR[lang] || STR.he;
  const v = table[key];
  return typeof v === 'function' ? v(...args) : v ?? key;
}

export function applyStaticLabels(lang) {
  const root = document.documentElement;
  root.lang = lang;
  root.dir = lang === 'he' ? 'rtl' : 'ltr';
  document.querySelectorAll('[data-layer]').forEach((btn) => {
    btn.textContent = t(lang, btn.dataset.layer);
  });
  document.getElementById('btn-lang').textContent = lang === 'he' ? 'EN' : 'עב';
  document.getElementById('btn-lang').setAttribute('aria-label', t(lang, 'language'));
  document.getElementById('btn-locate').setAttribute('aria-label', t(lang, 'locate'));
  document.getElementById('btn-play').setAttribute('aria-label', t(lang, 'play'));
  document.getElementById('credits').textContent = t(lang, 'credits');
}
